import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "23",
  fill: "none",
  viewBox: "0 0 22 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.75 10.708H14c-1.24 0-2.25 1.066-2.25 2.375v5.542C11.75 19.935 12.76 21 14 21h3.75c1.24 0 2.25-1.066 2.25-2.375v-5.542c0-1.31-1.01-2.375-2.25-2.375m.75 7.917c0 .436-.336.792-.75.792H14c-.414 0-.75-.356-.75-.792v-5.542c0-.436.336-.791.75-.791h3.75c.414 0 .75.355.75.791zm-.75-3.96c0 .436-.335.791-.75.791h-2.25c-.415 0-.75-.355-.75-.792s.335-.791.75-.791H17c.415 0 .75.354.75.791m0 2.377c0 .437-.335.791-.75.791h-2.25c-.415 0-.75-.354-.75-.791s.335-.792.75-.792H17c.415 0 .75.355.75.792m-9-5.542c2.482 0 4.5-2.13 4.5-4.75S11.232 2 8.75 2s-4.5 2.13-4.5 4.75 2.018 4.75 4.5 4.75m0-7.917c1.655 0 3 1.42 3 3.167s-1.345 3.167-3 3.167c-1.654 0-3-1.42-3-3.167s1.346-3.167 3-3.167m1.5 10.292c0 .437-.335.792-.75.792h-.75c-2.894 0-5.25 2.486-5.25 5.541 0 .437-.335.792-.75.792S2 20.645 2 20.208c0-3.928 3.028-7.125 6.75-7.125h.75c.415 0 .75.355.75.792"
    }, null, -1)
  ]))]))
}
export default { render: render }